(() => {
    class ManageTargetSourceController {
        name;
        description;
        source;
        status;
        type;
        brandId;
        selectedTestStore;
        selectedDataSource;
        queryName;
        customDataSource;
        showCustomDataSource;
        showTestStore;
        _dataSources = ["GetCustomersStreaming", "GetCustomers", "Custom"];
        _statuses = [];
        _types = [];
        _testStores = [];

        constructor(
            $scope,
            $state,
            $stateParams,
            $timeout,
            $uibModal,
            notify,
            CampaignDesignerService,
            PermissionService,
            ErrorService,
            StoresService,
            DashboardConfig
        ) {
            this._scope = $scope;
            this._modal = $uibModal;
            this._timeout = $timeout;
            this._notify = notify;
            this._state = $state;
            this._campaignDesignerService = CampaignDesignerService;
            this._permissionService = PermissionService;
            this._errorService = ErrorService;
            this._storesService = StoresService;
            this._dashboardConfig = DashboardConfig;
            this._targetSourceId = $stateParams.id;
            this.brandId = $stateParams.brandId;
            this.isExistingTargetSource = !!this._targetSourceId;
            this.setHeading();

            this.checkUserAccessToCampaignDesigner();
            $scope.saveTargetSource = this.saveTargetSource.bind(this);
            $scope.testTargetSource = this.testTargetSource.bind(this);
            this._statuses = Object.entries(Dashboard.Models.Lookups.CampaignTargetSourceStatuses)
                .map(([key, value]) => ({key,value}))
                .filter(x => x.value !== Dashboard.Models.Lookups.CampaignTargetSourceStatuses.All);
            this._types = Object.entries(Dashboard.Models.Lookups.CampaignLevelsWithoutAll).map(([key, value]) => ({key,value}));

            this.loadData().catch((e) => {
                this._errorService.showError("There was an issue loading the page", e)
            });

            $scope.$watch("$ctrl.selectedDataSource", this.dataSourceChanged.bind(this));
            $scope.$watch("$ctrl.queryName", this.queryNameChanged.bind(this));
            $scope.$watch("$ctrl.customDataSource", this.setSource.bind(this));
            $scope.$watch("$ctrl.type", this.typeChanged.bind(this));
        }

        checkUserAccessToCampaignDesigner() {
            const { Permissions } = Dashboard.Models.Lookups;
            if (!this._permissionService.doesUserHavePermissionForContext(Permissions.CampaignDesignerAccess)) {
                this._permissionService.navigateToAccessDenied();
            }
        };

        setHeading() {
            if (this.isExistingTargetSource) {
                this._scope.manageTargetSourceHeading = "Edit Target Source";
                return;
            }
            this._scope.manageTargetSourceHeading = "Add a Target Source";
        }

        async loadData() {
            this._scope.isLoadingTargetSource = true;
            await Promise.all([
                await this.fetchTargetSource(),
                await this.fetchTestStores()
            ]);

            this._timeout(this.updateUI.bind(this))
            this._scope.isLoadingTargetSource = false;
        }

        async fetchTargetSource() {
            this._targetSource = new CampaignTargetSource();
            if (!this.isExistingTargetSource) {
                return;
            }
            try {
                const results = await this._campaignDesignerService.getTargetSourceById(this._targetSourceId);
                this._targetSource = new CampaignTargetSource().initialiseCampaignTargetSource(results.data);
            } catch (e) {
                this._errorService.showError(
                    "An error occurred while trying to fetch target source data",
                    e
                );
            }
        }

        async fetchTestStores() {
            try {
                const storesResult = await this._storesService.getStoresForBrand(this.brandId, true);
                this._testStores = storesResult.data.Stores;
                if (this._testStores.length === 0) {
                    this._errorService.showError("No stores for this brand");
                    this.navigateToTargetSourcesListPage();
                }
            } catch (e) {
                this._errorService.showError(
                    "An error occurred while trying to fetch target source data",
                    e
                );
            }
        };

        updateUI() {
            this.name = this._targetSource.Name;
            this.description = this._targetSource.Description;
            this.source = this._targetSource.Source;
            this.status = this._targetSource.StatusId;
            this.type = this._targetSource.CampaignLevelId;
            this.selectedTestStore = this._targetSource.TestStoreId
                ? this._targetSource.TestStoreId
                : this._testStores[0].Id;

            this.analyticsCode = this._targetSource.AnalyticsCode;
            this.customDataSource = this.getDataSourceFromTargetSource();
            this.queryName = this.getQueryNameFromTargetSource();
            this.selectedDataSource = this.getSelectedDataSource();
            this.showCustomDataSource = this.selectedDataSource === "Custom";
            this.showTestStore = this.type === Dashboard.Models.Lookups.CampaignLevelsWithoutAll.Store;
            this.setSource();
        }

        dataSourceChanged() {
            this.showCustomDataSource = this.selectedDataSource === "Custom";
            this.setSource();
        }

        queryNameChanged() {
            this.setSource();
        }

        setSource() {
            const dataSource = this.showCustomDataSource
                ? this.customDataSource
                : this.selectedDataSource;
            this.source = `${this._dashboardConfig.ReportioUrl}/api/query/execute?name=${dataSource}&target=${this.queryName}`;
        }

        getDataSourceFromTargetSource() {
            if (this.showCustomDataSource || !this.source) {
                return "";
            }
            let url = new URL(this.source);
            let searchParams = new URLSearchParams(url.search);
            let name = searchParams.get("name");
            if (name) {
                return name;
            }
            return "";
        }

        getQueryNameFromTargetSource() {
            if (this.source) {
                let url = new URL(this.source);
                let searchParams = new URLSearchParams(url.search);
                let target = searchParams.get("target");
                if (target) {
                    return target;
                }
            }
            return "";
        }

        getSelectedDataSource() {
            const dataSource = this.getDataSourceFromTargetSource();
            if (this._dataSources.some(x => x === dataSource)) {
                return dataSource;
            }
            return dataSource === "" ? "GetCustomersStreaming" : "Custom";
        }

        typeChanged() {
            this.showTestStore = this.type === Dashboard.Models.Lookups.CampaignLevelsWithoutAll.Store;
        }

        testTargetSource() {
            const modalTemplateUrl = "components/campaigndesigner/targetsources/testtargetsource/test-target-source-modal.678f3f80.html";
            this._modal.open({
                animation: true,
                templateUrl: modalTemplateUrl,
                controller: "TestTargetSourceModalController",
                size: "lg",
                backdrop: "static",
                resolve: {
                    proceed: () => this.saveTargetSource.bind(this),
                    failed: () => this.testFailed.bind(this),
                    source: () => this.source,
                    brandId: () => this.brandId,
                    testStoreId: () => this.selectedTestStore
                }
            });
        }

        testFailed() {
            this._notify.warning("The target source test has failed. Only target sources that are valid can be saved.");
        }

        async saveTargetSource() {
            this._scope.submitted = true;
            if (!this._scope.targetSourceInfo.$valid) {
                return;
            }
            if (this._scope.isLoadingTargetSource) {
                return;
            }

            const targetSourceModel = {
                Id: this._targetSourceId,
                Name: this.name,
                Description: this.description,
                Source: this.source,
                CampaignLevelId: this.type,
                StatusId: this.status,
                BrandId: this.brandId,
                TestStoreId: this.selectedTestStore,
                AnalyticsCode: this.analyticsCode
            };
            try {
                await this._campaignDesignerService.saveTargetSource(targetSourceModel);
                this._notify.success("The target source was successfully saved");
                this.navigateToTargetSourcesListPage();
            } catch (e) {
                this._errorService.showError("An error occurred when trying to save the target source", e);
            }
        }

        navigateToTargetSourcesListPage() {
            this._state.go(
                Dashboard.helpers.stateHelper.getParentState(this._state.current.name), {
                    brandId: this.brandId,
                });
        }
    }

    angular.module("dashboard")
        .component("manageTargetSource",
            {
                templateUrl: "components/campaigndesigner/targetsources/managetargetsource/manage-target-source.271e2e7d.html",
                bindings: {},
                controller: [
                    "$scope",
                    "$state",
                    "$stateParams",
                    "$timeout",
                    "$uibModal",
                    "notify",
                    "CampaignDesignerService",
                    "PermissionService",
                    "ErrorService",
                    "StoresService",
                    "DashboardConfig",
                    ManageTargetSourceController
                ]
            });
})();
